const exported = {
  LIST_TO_LOOKUP_THRESHOLD: 20000,

  // TODO: we should change this implementation to fetch all memberships/invitations instead of
  //  having a hardcoded limit. https://coursera.atlassian.net/browse/DG-3832
  Pagination: {
    // Highest number of members in a group as of 2022/05/24 is 6987
    // https://tools.coursera.org/mega/queryExecutionLog/QUERY~aKyNgNvCEey4SouAw5s5zw~1~1653438857086
    MEMBERS_LIMIT: 10000,
    // Highest number of invitations for a group as of 2022/05/24 is 2414
    // https://tools.coursera.org/mega/queryExecutionLog/QUERY~-Kh94Nu4EeyyAf1cKJ6b-w~1~1653434803921
    INVITATIONS_LIMIT: 10000,
  },

  ResendInvitationState: {
    IDLE: 'idle',
    SENDING: 'sending',
    SENT: 'sent',
    FAILED: 'failed',
  },

  DeleteState: {
    IDLE: 'idle',
    DELETING: 'deleting',
    DELETED: 'deleted',
    FAILED: 'failed',
  },

  InviteState: {
    IDLE: 'idle',
    SENDING: 'saving',
    SENT: 'saved',
    FAILED: 'failed',
  },

  SearchState: {
    IDLE: 'idle',
    SEARCHING: 'searching',
    SUCCEEDED: 'searched',
    FAILED: 'failed',
  },
};

export default exported;

export const { LIST_TO_LOOKUP_THRESHOLD, Pagination, ResendInvitationState, DeleteState, InviteState, SearchState } =
  exported;
